module.exports = __webpack_public_path__ + "img/ic_wangluo@2x.dbf7dea1.png";